export default __webpack_public_path__ + "static/media/Close.fe11ec6a.svg";